// © Microsoft Corporation. All rights reserved.

import {
    SocialExperienceRenderErrorComment,
    SocialExperienceRenderErrorUnknownComponent
} from "@msnews/diagnostics";

import { Comment } from "./comment/Comment";

export const RenderErrors = {
    [Comment.name]: SocialExperienceRenderErrorComment,
    UnknownComponent: SocialExperienceRenderErrorUnknownComponent
};